import OfferEditPage from './OfferEditPage';

export default OfferEditPage;
